import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getWindow } from '../../utils/environment';
import { scrollToElementWhenReady } from '../../utils/helpers';

const ScrollToTop = () => {
  const { pathname, search, hash, state } = useLocation();
  const scrollTarget =
    (typeof state?.scrollTo === 'string' && state.scrollTo) ||
    hash?.replace(/^#/, '') ||
    '';

  useEffect(() => {
    const win = getWindow();
    if (!win) return;

    if (scrollTarget) {
      scrollToElementWhenReady(scrollTarget);
      return;
    }

    win.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname, search, hash, scrollTarget]);

  return null;
};

export default ScrollToTop;
